// Generado desde design-system/tokens/palette.ts — no editar; edita el .ts/.tsx y corre build-ds.
/**
 * Data Bunker · paletas para gráficas (espejo JS de tokens.css).
 * ECharts dibuja en canvas y no lee variables CSS: estos valores deben
 * coincidir 1:1 con --db-chart-* de tokens.css (lo revisa scripts/validate).
 *
 * Validación (skill dataviz · validate_palette):
 *   claro  (sup. #F8FAFC): CVD adyacente ΔE 16.8 · normal 21.0 · slots 1-3 all-pairs OK
 *   oscuro (sup. #0B2644): CVD adyacente ΔE 19.1 · normal 21.4 · todas ≥ 3:1
 * Reglas: orden fijo, nunca ciclar; la 9ª serie se agrupa en "Otros";
 * scatter/mapas/small multiples: máximo 3 series (slots 1-3).
 */
export const BRAND = {
    navy: '#062341', // Pantone 289 C
    blue: '#073C5C', // Pantone 302 C
    cyan: '#30A7B5', // Pantone 631 C
    orange: '#F68D2E', // Pantone 715 C
};
export const CATEGORICAL = {
    light: ['#005B8C', '#F48D31', '#1CA8B7', '#9E7C00', '#886ACF', '#38964D', '#6079D3', '#C9593D'],
    dark: ['#0072C4', '#DD6B00', '#00A4B7', '#9B7900', '#8567CC', '#35934A', '#5D76D0', '#C6563A'],
};
/** Secuencial (magnitud): azul de marca, claro → oscuro. Para ordinal usar 400–800. */
export const SEQUENTIAL_BLUE = {
    100: '#E1F1FE', 200: '#BEDCF3', 300: '#96C4E7', 400: '#6AA9D8', 500: '#3D8EC5',
    600: '#1272AB', 700: '#005B8C', 800: '#004770', 900: '#003455',
};
export const SEQUENTIAL_ORANGE = {
    100: '#FFEADB', 200: '#F7CEB1', 300: '#EFAD7D', 400: '#E2883E', 500: '#CD6600',
    600: '#AD4C00', 700: '#8C3A00', 800: '#6F2B00', 900: '#541E00',
};
export const SEQUENTIAL_CYAN = {
    100: '#DDF3F6', 200: '#B8E0E6', 300: '#8ACAD3', 400: '#53B2BE', 500: '#0098A7',
    600: '#007D8D', 700: '#006472', 800: '#004F5A', 900: '#003A43',
};
/** Divergente (polaridad): naranja ← gris neutro → azul. Igual número de pasos por brazo. */
export const DIVERGING = {
    light: ['#8C3A00', '#CD6600', '#EFAD7D', '#E0E5E9', '#96C4E7', '#3D8EC5', '#005B8C'],
    dark: ['#EFAD7D', '#CD6600', '#8C3A00', '#343F47', '#005B8C', '#3D8EC5', '#96C4E7'],
};
/** Estado: significado reservado, siempre con ícono + texto. */
export const STATUS = { good: '#0CA30C', warning: '#FAB219', serious: '#EC835A', critical: '#D03B3B' };
/** Cromo de gráfica por tema (texto nunca usa el color de la serie). */
export const CHROME = {
    light: {
        surface: '#F8FAFC', ink: '#062341', ink2: '#3D5570', ink3: '#52667D',
        grid: 'rgba(6,35,65,0.08)', axis: 'rgba(6,35,65,0.22)', muted: '#8A9AAD',
        pos: '#1C7340', neg: '#B83038',
        tooltipBg: 'rgba(255,255,255,0.86)', tooltipBorder: 'rgba(6,35,65,0.12)',
        tooltipShadow: '0 18px 40px -18px rgba(6,35,65,0.35)',
    },
    dark: {
        surface: '#0B2644', ink: '#EAF2FA', ink2: '#B4C5D8', ink3: '#8DA1B8',
        grid: 'rgba(255,255,255,0.07)', axis: 'rgba(255,255,255,0.22)', muted: '#6F86A0',
        pos: '#3DD68C', neg: '#FF7A85',
        tooltipBg: 'rgba(11,38,68,0.88)', tooltipBorder: 'rgba(255,255,255,0.14)',
        tooltipShadow: '0 22px 48px -18px rgba(0,6,16,0.9)',
    },
};
export const FONT = {
    sans: "'Open Sans', system-ui, -apple-system, 'Segoe UI', sans-serif",
    display: "'Oswald', 'Arial Narrow', system-ui, sans-serif",
};
